import React from 'react';
import { Routes, Route, Navigate, useParams } from "react-router-dom";

interface ParamNavigateProps {
	to: string;
	params: URLSearchParams;
}

function ParamNavigate({ to, params }: ParamNavigateProps) {
	let url = to;

	if (params.size > 0) {
		url += '?';

		params.forEach((value, key) => {
			url += `${key}=${encodeURIComponent(value)}&`;
		});
	}

	return <Navigate to={url} />;
}

function TenantEmailSettingsRedirect() {
	const { tenantID } = useParams();
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	return <ParamNavigate to={`/t/${tenantID}/settings/email`} params={urlParams} />;
}

interface RedirectConfig {
	path: string;
	redirect: string;
}

type RedirectItem = string | RedirectConfig;

export default function RedirectRoutes() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	const redirects: RedirectItem[] = [
		{ path: '/emailsettings/*', redirect: '/settings/email' },
		'/auth/login',
		'/auth/logout',
		'/auth/complete',
		'/auth/verify',
		{ path: '/auth/failure', redirect: '/auth/login' },
		'/auth/resetpassword',
		'/auth/invite'
	];

	return (
		<Routes>
			<Route path="/emailsettings/tenant/:tenantID/*" element={<TenantEmailSettingsRedirect />} />
			{redirects.map((redirect) => {
				if (typeof redirect === 'string') {
					return <Route key={redirect} path={redirect} element={<ParamNavigate to={redirect} params={urlParams} />} />;
				} else {
					return <Route key={redirect.path} path={redirect.path} element={<ParamNavigate to={redirect.redirect} params={urlParams} />} />;
				}
			})}
		</Routes>
	);
}
